import {
  IconCheck,
  IconClose,
  IconDeliveryStepOneCircle,
  IconDeliveryStepTwoCircle,
  IconDeliveryStepThreeCircle,
  IconReturn,
  Text,
} from "@idg-web-platform/pulse";
import css from "../orderSummary.module.css";
import { StatusKind, statusStyle } from "../statusBadge.tsx";
import { ShipmentStatus } from "../orderSummary.tsx";
import classNames from "classnames";
import { VNode } from "preact";

function statusRowIcon(kind: StatusKind): [VNode, string | undefined] {
  switch (kind) {
    case StatusKind.Received:
      return [<IconDeliveryStepOneCircle />, css.shipmentIconGreen];
    case StatusKind.Processed:
      return [<IconDeliveryStepTwoCircle />, css.shipmentIconGreen];
    case StatusKind.Shipped:
      return [<IconDeliveryStepThreeCircle />, css.shipmentIconGreen];
    case StatusKind.Delivered:
      return [<IconCheck />, css.shipmentIconGreen];
    case StatusKind.Cancelled:
      return [<IconClose />, css.shipmentIconRed];
    case StatusKind.Returned:
      return [<IconReturn />, undefined];
  }
}

function packageLabel(shipment: ShipmentStatus): string | undefined {
  if (shipment.total > 1) return `Paket ${shipment.index} / ${shipment.total}`;
  if (shipment.total > 0) return "Paket";
  return undefined;
}

export function ShipmentStatusRow({ shipment }: { shipment: ShipmentStatus }) {
  const [label] = statusStyle(shipment.status);
  const [icon, iconColor] = statusRowIcon(shipment.status.kind);
  const pkg = packageLabel(shipment);

  return (
    <div
      className={classNames(
        css.shipmentStatusRow,
        shipment.status.kind === StatusKind.Cancelled && css.shipmentStatusCancelled,
      )}
    >
      {pkg && <Text removeMargin={true}>{pkg}</Text>}
      <Text
        class={css.statusLabel}
        sizeStep={0}
        fontStyle={"bold"}
        removeMargin={true}
        element={"span"}
      >
        {label}
      </Text>
      <span className={iconColor}>{icon}</span>
    </div>
  );
}
